import React, { Component } from "react";
import ChartistGraph from "react-chartist";
import { Grid, Row, Col, FormGroup, InputGroup,ControlLabel,FormControl} from "react-bootstrap";
import { Bar } from 'react-chartjs-2';
import { auth, db } from "firedb/firebase";
import ReactEcharts from 'echarts-for-react';
import { Card } from "components/Card/Card.jsx";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
import {
    dataPie,
    legendPie,
    dataSales,
    clientsActive,
    clientsNew,
    responsiveSales,
    legendSales,
} from "variables/Variables.jsx";

// import './Grafic.css';

const option = {
    title: {
        text: 'Клиенты'
    },
    
    backgroundColor: '#fff',

    colors : ['#cccccc','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'],

    tooltip: {},
    legend: {
        data:['Sales'],
    },
    xAxis: {
        data: ["june","july","august","september","october","november", "december", "january", "febrary", "march", "april", "may",
        "june","july","august","september","october","november", "december", "january", "febrary", "march", "april", "may",
        "june","july","august","september","october","november", "december", "january", "febrary", "march", "april", "may"]
    },
    dataZoom: [
        {
            type: 'inside'
        }
    ],
    yAxis: {},
    series: [{
        // name: 'Sales',
        type: 'line',
        data: [5, 5, 5, 5, 5, 5, 5, 32, 36, 10, 25, 45, 5, 20, 36, 10, 10, 20,30, 32, 36, 10, 25, 45, 5, 20, 36, 10, 10, 20,30, 32, 36, 10, 25, 45]
    }],
};

const init_state = {
    NumClients: 0,
    NumActiveClients: 0,
    SumClientPoints: 0,
    AvgObtain: 0,
    AvgSpend: 0,
    CompanyUID: ''
}
 const data = {
     labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
     datasets: [{
         label: '# of Votes',
         type: 'line',
         data: [12, 19, 3, 5, 2, 3],
         backgroundColor: [
             'rgba(255, 159, 64, 0)'
             ],
         borderColor: [
             'rgba(54, 162, 235, 1)',
             ],

     }]
 };


class Grafic extends Component {


    constructor(props) {
        super(props);
        this.state = {...init_state};
    }

    componentDidMount() {
        const { datasets } = this.refs.chart.chartInstance.data
        console.log(datasets[0].data);
    }

    render() {
        return (
    <div className="content">
    <Grid fluid>
        <Row>
            <div className="col-md-5">
                <FormGroup>
                    <ControlLabel>Дата начала периода</ControlLabel>
                    <FormControl
                        type="date"
                        bsClass="form-control"
                    />
                </FormGroup>
            </div>

            <div className="col-md-7">
                <FormGroup>
                    <ControlLabel>Дата окончания периода</ControlLabel>
                    <FormControl
                        type="date"
                        bsClass="form-control"
                    />
                </FormGroup>
            </div>
        </Row>
      <Row>
        <Col lg={12} sm={12}>
            <div>
                <h2>График</h2>
                <Bar ref="chart" data={data} />
            </div>
        </Col>
      </Row>
    </Grid>
    </div>
        );
    }
}

export default Grafic;



// WEBPACK FOOTER //
// ./src/views/Grafic/Grafic.jsx